// 模板基础信息表单项
export const TemplateBasicInfoFormItems = [
  {
    label: '模板名称',
    type: 'input',
    prop: 'templateName',
    placeholder: '请输入模板名称',
    maxlength: 50,
    trim: true,
    span: 24
  },
  {
    label: '背景图片',
    type: 'upload',
    prop: 'backgroundImage',
    multiple: false,
    accept: '.jpeg,.jpg,.png,.gif',
    uploadAttrs: {
      dialogTitle: '上传背景图片',
      tip: '支持jpg、png、jpeg、gif格式，尺寸要求850 * 678，大小1M以内',
      sizeLimit: 1,
      aspectLimit: [850, 678]
    },
    listType: 'image',
    countLimit: 1,
    autoHeight: true,
    span: 24
  }
]
